(function() {
	'use strict';

	angular.module('claimsApp').controller('ClaimAdjustInfoController',
			ClaimAdjustInfoController);

	ClaimAdjustInfoController.$inject = [ '$scope', '$state', '$log','$resource','NgTableParams','Upload','authExpiredInterceptor','$timeout',
	                                      '$base64','ClaimAdjustInfo','CLAIM_TYPE','$filter','FORMAT_DATE','$window','GLOBAL_URL',
	                                      'ClaimRegistration','$stateParams','FileNetService','$uibModal','CommonService' ];

	function ClaimAdjustInfoController($scope, $state, $log, $resource,NgTableParams,Upload,authExpiredInterceptor,$timeout,
			$base64,ClaimAdjustInfo,CLAIM_TYPE,$filter,FORMAT_DATE,$window,
			GLOBAL_URL,ClaimRegistration,$stateParams,FileNetService,$uibModal,CommonService) {
		
		$scope.CLAIM_TYPE = CLAIM_TYPE;
		// init all data
		var claimAdjustInfoCtr = this;
		claimAdjustInfoCtr.policyIsTPDAndRO1 = false;
		claimAdjustInfoCtr.claimCase  = {
			
		};
		
		claimAdjustInfoCtr.searchCompleted = false;
		
		claimAdjustInfoCtr.disableSentBtn = false;
		
		claimAdjustInfoCtr.disableAll = false;
		
		claimAdjustInfoCtr.pendingNoticeGroupValid = [];
		claimAdjustInfoCtr.pendingNoticeGroupInvalid = [];

		$scope.$watch('claimAdjustInfoCtr.claimCase.registerDate', function(formattedDate){
			claimAdjustInfoCtr.claimCase.registerDateStr = $filter('date')(formattedDate, FORMAT_DATE);
    	});
		
		$scope.$watch('claimAdjustInfoCtr.claimCase.docCompletedDate', function(formattedDate){
			claimAdjustInfoCtr.claimCase.docCompletedDateStr = $filter('date')(formattedDate, FORMAT_DATE);
    	});
		
		$scope.$watch('claimAdjustInfoCtr.claimCase.eventDate', function(formattedDate){
			claimAdjustInfoCtr.claimCase.eventDateStr = $filter('date')(formattedDate, FORMAT_DATE);
    	});
		
		
		
		$scope.$watch('claimAdjustInfoCtr.claimCase.hopitalStartDate', function(formattedDate){
			claimAdjustInfoCtr.claimCase.hopitalStartDateStr = $filter('date')(formattedDate, FORMAT_DATE);
    	});
		
		$scope.$watch('claimAdjustInfoCtr.claimCase.hopitalEndDate', function(formattedDate){
			claimAdjustInfoCtr.claimCase.hopitalEndDateStr = $filter('date')(formattedDate, FORMAT_DATE);
    	});
		
		
		claimAdjustInfoCtr.datePickerOpenStatus = {};
		

		

		
		claimAdjustInfoCtr.init = function() {
			if($stateParams.claimNum) {
				claimAdjustInfoCtr.claimCase.claimNum = $stateParams.claimNum;
				claimAdjustInfoCtr.searchClaimNum();
			}
		}

		// checkSignature from kofax
		claimAdjustInfoCtr.checkSignature = function (policyNum){
			if (policyNum == undefined || policyNum == null) return false;
			var policyNumArray = policyNum.split(',');
			FileNetService.query({method:'get-list-poldoc-by-policylist',policyList :policyNumArray}, function(result){
				if(result.length >0){
					claimAdjustInfoCtr.animationsEnabled = true;
					var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : claimAdjustInfoCtr.animationsEnabled,
						templateUrl : GLOBAL_URL+'partial?uri=ga/signature/signature-dialog',
						controller : 'SignatureDialogController as signatureDlgCtrl',
						size : 'lg',
						resolve : {
							items : function() {
								return result;//tranfer data for dialog
							}
						}
					});
					modalInstance.result.then(
					function(result) {
					},
					function(error){
					});
				}else{
					$scope.addAlert('File chữ ký PO không tồn tại.Vui lòng kiểm tra lại','warning');
				}
    		},
    		function(error){
    		});
		}
		
		claimAdjustInfoCtr.openCalendar1 = function(row) {
			row.isOpen = true;
		}
		
		claimAdjustInfoCtr.submit =function(){
			var data = [];
			claimAdjustInfoCtr.disableAll = true;
			claimAdjustInfoCtr.claimCase.docList = claimAdjustInfoCtr.originalDocList;
			if (claimAdjustInfoCtr.form.file.$valid && claimAdjustInfoCtr.attachment) {
				data['file'] = claimAdjustInfoCtr.attachment;
				var json = JSON.stringify(claimAdjustInfoCtr.claimCase);
				$log.debug(json);
				data['claimAdjustInfoDto'] = new Blob([json], {type: "application/json"});
			 }
			
			 Upload.upload({
		            url: GLOBAL_URL + 'api/ga/claims/adjust-info/do-submit-adjust?access_token=' + authExpiredInterceptor.getToken(),
		            data: data
		        }).then(function (resp) {
		            $log.debug('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
		            claimAdjustInfoCtr.disableAll = true;
		            
		          //open download ack letter
		            if (resp.data.healthCare) {
		            	
			            $timeout(function(){
			            	$window.open(GLOBAL_URL +"ga/claims/gen-adjust-info-ack-letter/"+$base64.encode(resp.data.claimAdjustInfoId + ',' + resp.data.claimNum)+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
			            },3000);
		            } else {
			            $timeout(function(){
			            	$window.open(GLOBAL_URL +"ga/claims/gen-adjust-info-ack-letter/"+$base64.encode(resp.data.claimAdjustInfoId)+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
			            },3000);
		            }
		        }, function (resp) {
		        	$log.debug('Error status: ' + resp.status);
		        	if(resp.data!=null && resp.data[0].data =='failure'){
		        		claimAdjustInfoCtr.disableAll = true;
		        	}
		        	else {
		        		claimAdjustInfoCtr.disableAll = false;
		        	}
		        	
		        }, function (evt) {
		            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
		            $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
		        });		
		}
		
		
		claimAdjustInfoCtr.searchClaimNum = function(){
			if(!claimAdjustInfoCtr.claimCase.claimNum || claimAdjustInfoCtr.claimCase.claimNum.trim() ==''){
				$scope.addAlert('Vui lòng nhập số hồ sơ claim','warning');
				return;
			}
			if( claimAdjustInfoCtr.claimCase.ownerIdNum == undefined ||  claimAdjustInfoCtr.claimCase.ownerIdNum == null)
				claimAdjustInfoCtr.claimCase.ownerIdNum = '';

			ClaimAdjustInfo.searchClaimNum({claimNum:claimAdjustInfoCtr.claimCase.claimNum, clientIdNum: claimAdjustInfoCtr.claimCase.ownerIdNum},function(result){
				if((result.needToInputIDNumber == true)
					|| (claimAdjustInfoCtr.claimCase.ownerIdNum != ''
						&& claimAdjustInfoCtr.claimCaseownerIdNum != undefined
						&& claimAdjustInfoCtr.claimCase.ownerIdNum != null
						&& claimAdjustInfoCtr.claimCase.ownerIdNum != result.ownerIdNum
					))
				{
					document.getElementById("labelmessage").style.display = "block";
					return;
				}
				else{
					document.getElementById("labelmessage").style.display = "none";
					claimAdjustInfoCtr.claimCase.ownerIdNum == result.ownerIdNum;
				}

				claimAdjustInfoCtr.searchCompleted = true;
				claimAdjustInfoCtr.claimCase = result;
				claimAdjustInfoCtr.originalDocList = claimAdjustInfoCtr.claimCase.docList;
				if(result.claimType == 'TPD' && result.poType == 'RO1') {
					claimAdjustInfoCtr.policyIsTPDAndRO1 = true;
				}
				claimAdjustInfoCtr.requestLtrParams = new NgTableParams({
					 group: 'pendingNoticeId',
					 count : 1000000000
				},
				{
					defaultSort: 'desc',
					dataset : claimAdjustInfoCtr.claimCase.requestLetterList,
					counts : []
				});
				claimAdjustInfoCtr.docParams = new NgTableParams({
					count : 1000000000
					
				}, {
					 dataset: angular.copy(claimAdjustInfoCtr.originalDocList),
					 counts : []
				});
				
				ClaimRegistration.getDocumentByType({claimType:claimAdjustInfoCtr.claimCase.claimType},function(result){
					claimAdjustInfoCtr.documents = result;
				})
			});
		}
		
		claimAdjustInfoCtr.searchByPolicyNum = function(){
			if(!claimAdjustInfoCtr.claimCase.policyNum || claimAdjustInfoCtr.claimCase.policyNum.trim() ==''){
				$scope.addAlert('Vui lòng nhập số hợp đồng','warning');
				return;
			}
			if( claimAdjustInfoCtr.claimCase.ownerIdNum == undefined ||  claimAdjustInfoCtr.claimCase.ownerIdNum == null)
				claimAdjustInfoCtr.claimCase.ownerIdNum = '';

			ClaimAdjustInfo.searchPolicyNum({policyNum:claimAdjustInfoCtr.claimCase.policyNum, clientIdNum: claimAdjustInfoCtr.claimCase.ownerIdNum},function(result){
				claimAdjustInfoCtr.animationsEnabled = true;
				if(result.length ==0) {
					$scope.addAlert('Không tìm thấy hồ sơ','warning');
				}
				else
				{
					if((result[0].needToInputIDNumber == true)
						|| (claimAdjustInfoCtr.claimCase.ownerIdNum != ''
							&& claimAdjustInfoCtr.claimCaseownerIdNum != undefined
							&& claimAdjustInfoCtr.claimCase.ownerIdNum != null
							&& claimAdjustInfoCtr.claimCase.ownerIdNum != result[0].ownerIdNum
						))
					{
						document.getElementById("labelmessage").style.display = "block";
						claimAdjustInfoCtr.claimCase.ownerIdNum = '';
						return;
					}
					else{
						document.getElementById("labelmessage").style.display = "none";
						claimAdjustInfoCtr.claimCase.ownerIdNum = result[0].ownerIdNum;
					}

					if(result.length >=2){
						var modalInstance =
							//show dialog
							$uibModal.open({
								animation : claimAdjustInfoCtr.animationsEnabled,
								templateUrl : GLOBAL_URL+'partial?uri=ga/history/claim-search/claimcase-policies-dialog',
								controller : 'ClaimCasePoliciesController as claimCasePoliciesCtr',
								size : 'lg',
								resolve : {
									items : function() {
										return result;
									}
								}
							});
						modalInstance.result.then(function (selectedItem) {
							$log.debug(selectedItem);
							claimAdjustInfoCtr.claimCase.claimNum = selectedItem.claimNum;
							claimAdjustInfoCtr.searchClaimNum();
						})
					}
					if(result.length ==1){

						claimAdjustInfoCtr.claimCase.claimNum = result[0].claimNum;
						claimAdjustInfoCtr.searchClaimNum();
					}
				}
			});
		}
		claimAdjustInfoCtr.changeValidAll = function(pendingNoticeId){
			var pn = _.each(_.filter(claimAdjustInfoCtr.requestLtrParams.settings().dataset, function(value){ return value.pendingNoticeId == pendingNoticeId;}),function(requestLtr){
				if(requestLtr.valid) {
					requestLtr.valid = null;
					
				}
				else {
					if(requestLtr.invalid) {
						requestLtr.invalid = null;
						claimAdjustInfoCtr.pendingNoticeGroupInValid[pendingNoticeId] = null;
					}
					requestLtr.valid = true;
				}
				
			});
			
			
		}
		claimAdjustInfoCtr.changeInvalidAll = function(pendingNoticeId){
			var pn = _.each(_.filter(claimAdjustInfoCtr.requestLtrParams.settings().dataset, function(value){ return value.pendingNoticeId == pendingNoticeId;}),function(requestLtr){
				if(requestLtr.invalid) {
					requestLtr.invalid = null;
				}
				else {
					if(requestLtr.valid) {
						requestLtr.valid = null;
						claimAdjustInfoCtr.pendingNoticeGroupValid[pendingNoticeId] = null;
					}
					requestLtr.invalid = true;
				}
				
			});
		}
		claimAdjustInfoCtr.changeDoc = function(row){
			if(!row.documentCode) {
				row.documentName = '';
				return;
			}
			angular.forEach(claimAdjustInfoCtr.documents,function(doc){
				if(doc.documentCode ==row.documentCode) {
					row.documentName = doc.documentName;
				}
			})
		}
		claimAdjustInfoCtr.agentInfo = function (){
			if(claimAdjustInfoCtr.claimCase&&claimAdjustInfoCtr.claimCase.agentCode&&claimAdjustInfoCtr.claimCase.agentName) {
				return claimAdjustInfoCtr.claimCase.agentCode + " - "+ claimAdjustInfoCtr.claimCase.agentName;
			}
		}
		claimAdjustInfoCtr.surgery = function(){
			if(claimAdjustInfoCtr.claimCase&&claimAdjustInfoCtr.claimCase.surgeryCode&&claimAdjustInfoCtr.claimCase.surgeryName) {
				return claimAdjustInfoCtr.claimCase.surgeryCode + " - "+ claimAdjustInfoCtr.claimCase.surgeryName;
			}
		}
		claimAdjustInfoCtr.viewLetter = function(letterFileLogId){
			$window.open(GLOBAL_URL+'ga/claims/request-letter/download/'+$base64.encode(letterFileLogId)+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
		}
				
		claimAdjustInfoCtr.resetForm = function(){
			$state.transitionTo($state.current, {}, { 
	  			  reload: true, inherit: false, notify: true
	  		});
		}
		
		claimAdjustInfoCtr.requestLtrParams = new NgTableParams({
		},
		{
			defaultSort: 'desc',
			dataset : angular.copy(claimAdjustInfoCtr.claimCase.requestLetterList)       	
		});

		claimAdjustInfoCtr.deleteCount = 0;

		claimAdjustInfoCtr.documents = [];
		claimAdjustInfoCtr.docList = [];

		claimAdjustInfoCtr.originalDocList = angular.copy(claimAdjustInfoCtr.docList);

		
		claimAdjustInfoCtr.docParams = new NgTableParams({}, {
			 dataset: angular.copy(claimAdjustInfoCtr.originalDocList)
		});
		
		
		claimAdjustInfoCtr.add = function() {
		      claimAdjustInfoCtr.isEditing = true;
		      claimAdjustInfoCtr.isAdding = true;
		      claimAdjustInfoCtr.docParams.settings().dataset.unshift({doc:{},no:1,receivedDate:new Date(),remark:'',invalid:false});
		      // we need to ensure the user sees the new row we've just added.
		      // it seems a poor but reliable choice to remove sorting and move them to the first page
		      // where we know that our new item was added to
		      claimAdjustInfoCtr.docParams.sorting({});
		      claimAdjustInfoCtr.docParams.page(1);
		      claimAdjustInfoCtr.docParams.reload();
		}

		claimAdjustInfoCtr.cancelChanges = function() {
		      claimAdjustInfoCtr.resetTableStatus();
		      var currentPage = claimAdjustInfoCtr.docParams.page();
		      claimAdjustInfoCtr.docParams.settings({
		        dataset: angular.copy(claimAdjustInfoCtr.originalDocList)
		      });
		      // keep the user on the current page when we can
		      if (!claimAdjustInfoCtr.isAdding) {
		        claimAdjustInfoCtr.docParams.page(currentPage);
		      }
		    }

		claimAdjustInfoCtr.del = function(row) {
		      _.remove(claimAdjustInfoCtr.docParams.settings().dataset, function(item) {
		        return row === item;
		      });
		      claimAdjustInfoCtr.deleteCount++;
		      claimAdjustInfoCtr.tableTracker.untrack(row);
		      claimAdjustInfoCtr.docParams.reload().then(function(data) {
		        if (data.length === 0 && claimAdjustInfoCtr.docParams.total() > 0) {
		          claimAdjustInfoCtr.docParams.page(claimAdjustInfoCtr.docParams.page() - 1);
		          claimAdjustInfoCtr.docParams.reload();
		        }
		      });
		 }

		claimAdjustInfoCtr.hasChanges = function() {
		      return claimAdjustInfoCtr.tableForm.$dirty || claimAdjustInfoCtr.deleteCount > 0;
		 }

		claimAdjustInfoCtr.resetTableStatus = function() {
		      claimAdjustInfoCtr.isEditing = false;
		      claimAdjustInfoCtr.isAdding = false;
		      claimAdjustInfoCtr.deleteCount = 0;
		      claimAdjustInfoCtr.tableTracker.reset();
		      claimAdjustInfoCtr.tableForm.$setPristine();
		    }

		claimAdjustInfoCtr.saveChanges = function() {
	      claimAdjustInfoCtr.resetTableStatus();
	      var currentPage = claimAdjustInfoCtr.docParams.page();
	      claimAdjustInfoCtr.originalDocList = angular.copy(claimAdjustInfoCtr.docParams.settings().dataset);
	    }
	}
})();
